var React = require('react');

function ArrowNextInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_17","data-name":"Union 17","d":"M.291,10.9a1,1,0,0,1,0-1.414L7.78,2H1.708a1,1,0,1,1,0-2H10.19a1,1,0,0,1,1,.956l.354,8.129a1,1,0,1,1-2,.089L9.291,3.312,1.705,10.9A.985.985,0,0,1,1,11.191.985.985,0,0,1,.291,10.9Z","transform":"translate(7.915 0.001) rotate(45)","fill":"#fff"}));
}

ArrowNextInline.defaultProps = {"width":"16.079","height":"16.079","viewBox":"0 0 16.079 16.079"};

module.exports = ArrowNextInline;

ArrowNextInline.default = ArrowNextInline;
